import { TLanguage } from "@/api/v1_0";

export namespace Language {
  export const languages = [TLanguage.Ru];
}
